<template>
  <v-window-item :value="4" class="pa-3 fill-height">
    <div v-if="!loaded || uploading" class="fill-height">
      <div v-if="!loading" class="fill-height">
        <v-tabs v-model="activeTabOne" center-active bg-color="primary" dark grow>
          <v-tab style="width: 50%" rounded="0" color="white"> Generate from DEM </v-tab>
          <v-tab style="width: 50%" rounded="0" color="white"> Upload dike profile </v-tab>
        </v-tabs>
        <v-window class="py-3 fill-height" v-model="activeTabOne" color="primary">
          <v-window-item>
            <div class="pb-6">
              <UploadToBlobStorage
                ref="uploadToBlob"
                label="Upload .tif file"
                accept=".tif"
                :file="tiffFile"
                @setBlobFileName="setTiffFile"
              />
            </div>
            <v-tabs v-model="activeTabTwo" color="primary">
              <v-tab rounded="0"> Upload </v-tab>
              <v-tab rounded="0"> Generate </v-tab>
            </v-tabs>
            <v-window v-model="activeTabTwo" class="pa-3">
              <v-window-item>
                <ShapeFileUpload
                  :disabled="uploading"
                  @fetchGeometryFieldNames="fetchGeometryFieldNames"
                  @updateFieldName="fieldName = $event"
                  @updateFileName="fileName = $event"
                  :field-name="fieldName"
                  :field-names="fieldNames"
                  :file-name="fileName"
                  :loading-field="loadingField"
                />
              </v-window-item>
              <v-window-item>
                <div class="mt-6">
                  <v-row>
                    <v-col cols="8">
                      <v-slider
                        step="1"
                        color="primary"
                        v-model="startDistance"
                        thumb-label
                        label="Start distance"
                        min="0"
                        max="100"
                      ></v-slider>
                    </v-col>
                    <v-col cols="3" class="pr-0 pl-0 pt-2">
                      <v-text-field
                        density="compact"
                        suffix="m"
                        variant="outlined"
                        type="number"
                        hide-details
                        v-model="startDistance"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8">
                      <v-slider
                        step="1"
                        v-model="interval"
                        thumb-label
                        label="Interval"
                        color="primary"
                        min="1"
                        max="500"
                      ></v-slider>
                    </v-col>
                    <v-col cols="3" class="pr-0 pl-0 pt-2">
                      <v-text-field
                        density="compact"
                        suffix="m"
                        variant="outlined"
                        type="number"
                        hide-details
                        v-model="interval"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-window-item>
            </v-window>
          </v-window-item>
          <v-window-item>
            <ShapeFileUpload
              :disabled="uploading"
              @fetchGeometryFieldNames="fetchGeometryFieldNames"
              @updateFieldName="fieldName = $event"
              @updateFileName="fileName = $event"
              :field-name="fieldName"
              :field-names="fieldNames"
              :file-name="fileName"
              :loading-field="loadingField"
            />
          </v-window-item>
        </v-window>
      </div>

      <div style="height: 10%" class="py-3">
        <v-btn variant="text" @click="$emit('back')"> Back </v-btn>
        <v-btn
          variant="flat"
          class="float-right"
          :disabled="disabledButton"
          color="primary"
          :loading="uploading"
          @click="action()"
        >
          Upload & Continue
        </v-btn>
      </div>
    </div>
    <div v-else class="fill-height">
      <v-data-table
        fixed-header
        class="overflow-y-auto fill-height"
        hide-default-footer
        hide-default-header
        density="compact"
        :items-per-page="-1"
        :items="dikeProfiles.features"
        :headers="headers"
      >
        <template #bottom> </template>
        <template v-slot:[`item.properties.color`]="{ item }">
          <ProfileChip :item="item" />
        </template>
        <template v-slot:[`item.index`]="{ index }">
          {{ index + 1 }}
        </template>
      </v-data-table>
      <div class="py-3">
        <v-btn variant="flat" class="float-right" color="primary" @click="$emit('finish')">
          Finish
        </v-btn>
        <v-btn variant="text" @click="$emit('back')"> Back </v-btn>

        <v-btn @click="deleteAll" :loading="loadingDelete" variant="flat" color="error">
          Delete all
        </v-btn>
      </div>
    </div>
  </v-window-item>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import ShapeFileUpload from '@/components/dike/ShapeFileUpload.vue'
import UploadToBlobStorage from '@/components/dike/UploadToBlobStorage.vue'
import api from '../../api/api'
import ProfileChip from '@/components/dike/ProfileChip.vue'

export default {
  name: 'DikeProfileUploadShapeFileStep',
  components: { ProfileChip, UploadToBlobStorage, ShapeFileUpload },
  props: {
    step: {}
  },
  data: () => ({
    fileName: null,
    tiffFile: null,
    fieldNames: [],
    fieldName: null,
    uploading: false,
    loadingTiff: false,
    loadingField: false,
    loadingDelete: false,
    progressUpload: 0,
    interval: 100,
    startDistance: 0,
    activeTabOne: 0,
    activeTabTwo: 0,
    headers: [
      { title: '', value: 'properties.color', width: '20%' },
      { title: 'Index', value: 'index', width: '10%' },
      { title: 'Reference point', value: 'properties.name' }
    ]
  }),
  computed: {
    ...mapState('dikeProfiles', {
      loaded: (state) => state.loaded,
      loading: (state) => state.loading,
      dikeProfiles: (state) => state.items
    }),
    disabledButton() {
      if (this.activeTabOne === 0) {
        return !this.tiffFile || (!this.fieldName && this.activeTabTwo === 0)
      } else {
        return !this.fieldName
      }
    },
    tiffFileName() {
      return this.tiffFile ? this.tiffFile.name : null
    }
  },
  methods: {
    ...mapActions('dikeProfiles', {
      uploadDikeProfiles: 'upload',
      deleteDikeProfiles: 'deleteAll',
      generateDikeProfiles: 'generate',
      updateElevation: 'updateElevation'
    }),
    ...mapActions('project', {
      setUploadingDikeProfiles: 'setUploadingDikeProfiles'
    }),
    async action() {
      if (this.activeTabOne === 0 && this.activeTabTwo === 1) {
        await this.generate()
      } else {
        await this.uploadFile()
      }
    },
    setTiffFile(file) {
      file = file ? file : null
      this.tiffFile = file
    },
    async uploadFile() {
      this.uploading = true
      try {
        await this.$refs.uploadToBlob.uploadToBlob()
        const formData = new FormData()
        formData.append('file', this.fileName, this.fileName.name)
        formData.append('field', this.fieldName)
        formData.append('blobFile', this.tiffFileName)
        await this.uploadDikeProfiles(formData)
        await this.updateElevation({ blobFile: this.tiffFileName })
      } catch (e) {
        this.uploading = false
      }
      this.uploading = false
    },
    async generate() {
      this.uploading = true
      try {
        await this.$refs.uploadToBlob.uploadToBlob()
        await this.generateDikeProfiles({
          properties: {
            interval: parseFloat(this.interval),
            minimum_distance: parseFloat(this.startDistance),
            blobFile: this.tiffFileName
          }
        })
        await this.setUploadingDikeProfiles(true)
        this.$emit('finish')
      } catch (e) {
        console.log(e)
        this.uploading = false
      }
      this.uploading = false
    },
    resetSelectField: function () {
      this.loadingField = false
      this.fieldNames = []
      this.fieldName = null
    },
    async deleteAll() {
      this.loadingDelete = true
      await this.deleteDikeProfiles()
      this.loadingDelete = false
    },
    async fetchGeometryFieldNames() {
      this.loadingField = true
      const formData = new FormData()
      if (!this.fileName) {
        return this.resetSelectField()
      } else {
        formData.append('file', this.fileName, this.fileName.name)
        await api
          .post(`/dike_profiles/get_field_names/`, formData)
          .then((response) => {
            this.fieldNames = response.data
          })
          .catch((error) => {
            console.log(error)
            this.loadingField = false
          })
        this.loadingField = false
      }
    }
  }
}
</script>
